import React, { useEffect, useRef, useState } from "react";
import s from "./adaptiveWheel.module.scss";
import iphoneBorderImg from "../../../../../assets/img/wheelIphoneBorder.png";
import bomb from "../../../../../assets/wheelsThemes/blue/additions/bombBackgroundBL.svg";
import fog from "../../../../../assets/wheelsThemes/red/additions/fogButtonBL.svg";
import decoratorPurpleBackground from "../../../../../assets/wheelsThemes/purple/additions/decoratorPurpleBackgroundBL.svg";
import stoneTL from "../../../../../assets/wheelsThemes/blue/additions/stoneWheelTL.svg";
import stoneTR from "../../../../../assets/wheelsThemes/blue/additions/stoneWheelTR.svg";
import stoneBL from "../../../../../assets/wheelsThemes/blue/additions/stoneWheelBL.svg";
import stoneBR from "../../../../../assets/wheelsThemes/blue/additions/stoneWheelBR.svg";
import lightDecorator from "../../../../../assets/wheelsThemes/blue/additions/lightDecorator.svg";
import purpleCenter from "../../../../../assets/wheelsThemes/purple/additions/decoratorWheelCenter.svg";
import decoratorCenterWheel from "../../../../../assets/wheelsThemes/orange/additions/decoratorCenterWheel.svg";
import decoratorButton from "../../../../../assets/wheelsThemes/purple/additions/decoratorButtonTC.svg";
import decoratorPointer from "../../../../../assets/wheelsThemes/purple/additions/pointerDecoratorBC.svg";
import coin from "../../../../../assets/wheelsThemes/orange/additions/coinDecorator.svg";
import {
  calculateTextRadiusAdjustment,
  determineTextColor,
  getPointerStyle,
} from "../../Wheel/Wheel";

const drawWheel = (ctx, radius, wheelNumbers, currentWheel, angle) => {
  const image = new Image();
  image.src = currentWheel?.wheel;
  const segments = wheelNumbers.length;
  const degreesPerSegment = 360 / segments;

  image.onload = () => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.save();
    ctx.translate(radius, radius);
    ctx.rotate((Math.PI / 180) * (angle - 90));
    ctx.drawImage(image, -radius, -radius, radius * 2, radius * 2);

    wheelNumbers.forEach((number, index) => {
      const sectorAngle = degreesPerSegment * index - 27;
      const angleRad = (Math.PI / 180) * sectorAngle;

      const baseRadius = radius - 45;
      const textRadiusAdjustment = calculateTextRadiusAdjustment(currentWheel);
      const textRadius = baseRadius - textRadiusAdjustment;

      const x = textRadius * Math.cos(angleRad);
      const y = textRadius * Math.sin(angleRad);

      // if (currentWheel.background.includes("bonanza")) {
      //   ctx.font = "17px Arial";
      // } else {
      //   ctx.font = "20px Arial";
      // }
      ctx.fillStyle = determineTextColor(currentWheel, index);
      ctx.font = "14px Arial";
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate((Math.PI / 180) * (sectorAngle + 180));
      ctx.fillText(number, 0, 0, textRadius - 10);
      ctx.restore();
    });

    ctx.restore();
  };
};

const AdaptiveWheel = ({
  currentWheel,
  wheelNumbers,
  prelandTitle,
  spinButtonText,
  respinButtonText,
  winSector,
  popupTitle,
  popupButtonText,
  popupText,
}) => {
  const canvasRef = useRef(null);
  const [angle, setAngle] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);
  const [hasSpunOnce, setHasSpunOnce] = useState(false);
  const [currentRotation, setCurrentRotation] = useState(0);

  useEffect(() => {
    setIsSpinning(false);
    setShowPopup(false);
    setHasSpunOnce(false);
  }, [currentWheel]);

  useEffect(() => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext("2d");
      const radius = canvasRef.current.width / 2;
      drawWheel(ctx, radius, wheelNumbers, currentWheel, angle);
    }
  }, [wheelNumbers, currentWheel, angle]);

  const spinWheel = () => {
    setIsSpinning(true);

    const degreesPerSegment = 360 / wheelNumbers.length; // Скільки градусів на один сектор
    const halfSegmentOffset = degreesPerSegment / 2; // Додавання половини кута сектора для центрування

    // Враховуємо, що потрібен сектор ліворуч від поточного вибору
    const adjustmentForCorrectSector = degreesPerSegment; // Відняти кут одного сектора

    const winningSegmentDegrees =
      winSector * degreesPerSegment +
      halfSegmentOffset -
      adjustmentForCorrectSector;
    const offsetForWinningSegment = 360 - winningSegmentDegrees;

    const fullSpins = 5 * 360; // Кількість повних обертів для ефекту спіна
    const totalRotation =
      currentRotation +
      fullSpins +
      offsetForWinningSegment -
      (currentRotation % 360);

    setWheelStyle({
      transform: `rotate(${totalRotation}deg)`,
      transition: "transform 4s ease-in-out",
    });

    setTimeout(() => {
      setIsSpinning(false);
      setShowPopup(true);

      const newCurrentRotation = totalRotation % 360;
      setCurrentRotation(newCurrentRotation);

      setWheelStyle({
        transform: `rotate(${newCurrentRotation}deg)`,
        transition: "none",
      });
    }, 4000);
  };

  const processedPopupText = popupText?.replace(
    "{bonus}",
    wheelNumbers[winSector],
  );

  const [wheelStyle, setWheelStyle] = useState({});

  const [isAnimated, setAnimated] = useState(false);

  return (
    <div className={s.wheelContainer}>
      <img src={iphoneBorderImg} alt="" className={s.iphoneBorderWrapper} />

      <div
        className={s.prelandPreview}
        style={{
          backgroundImage: `url(${currentWheel?.background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {currentWheel?.wheel?.includes("blue") && (
          <img
            src={bomb}
            style={{
              position: "absolute",
              bottom: -20,
              left: -10,
              zIndex: 100,
            }}
          />
        )}

        {currentWheel?.wheel?.includes("red") && (
          <img
            src={fog}
            style={{ position: "absolute", bottom: -20, left: -10, zIndex: 1 }}
          />
        )}

        {currentWheel?.wheel?.includes("purple") && (
          <img
            src={decoratorPurpleBackground}
            style={{
              position: "absolute",
              bottom: -20,
              left: -10,
              zIndex: 100,
            }}
          />
        )}

        <div className={s.header}>
          {/*<img src={logo} alt="" className={s.prelandLogo}/>*/}
          <div className={s.call}>{prelandTitle}</div>
        </div>
        <div className={s.content}>
          {/*<img src={lightDecoratorBR} style={{position: "absolute", bottom: 0}}/>*/}

          {currentWheel?.wheel?.includes("blue") && (
            <>
              <img
                src={stoneTL}
                style={{
                  width: 100,
                  height: 100,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 100,
                }}
              />
              <img
                src={stoneTR}
                style={{
                  width: 100,
                  height: 100,
                  position: "absolute",
                  top: 0,
                  right: 0,
                  zIndex: 100,
                }}
              />
              <img
                src={stoneBL}
                style={{
                  width: 100,
                  height: 100,
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  zIndex: 100,
                }}
              />
              <img
                src={stoneBR}
                style={{
                  width: 100,
                  height: 100,
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  zIndex: 100,
                }}
              />

              <img
                src={lightDecorator}
                style={{
                  position: "absolute",
                  marginLeft: 30,
                  marginBottom: 10,
                  zIndex: 100,
                }}
              />
            </>
          )}

          {currentWheel?.wheel?.includes("red") && (
            <>
              <img
                src={lightDecorator}
                style={{
                  position: "absolute",
                  top: -50,
                  marginRight: 35,
                  zIndex: 100,
                }}
              />

              <img
                src={lightDecorator}
                style={{ position: "absolute", marginRight: 23, zIndex: 100 }}
              />

              <img
                src={lightDecorator}
                style={{
                  position: "absolute",
                  left: -40,
                  marginBottom: 90,
                  zIndex: 100,
                }}
              />

              <img
                src={lightDecorator}
                style={{
                  position: "absolute",
                  right: -10,
                  bottom: 20,
                  zIndex: 100,
                }}
              />
            </>
          )}

          {currentWheel?.wheel?.includes("purple") && (
            <>
              <img
                src={purpleCenter}
                style={{ position: "absolute", zIndex: 100 }}
              />
            </>
          )}

          {currentWheel?.wheel?.includes("orange") && (
            <>
              <img
                src={decoratorCenterWheel}
                style={{ position: "absolute", zIndex: 100 }}
              />
            </>
          )}

          <img
            className={s.pointer}
            src={currentWheel?.pointer}
            style={getPointerStyle(currentWheel)}
          />
          <canvas
            ref={canvasRef}
            width="285"
            height="285"
            className={isAnimated ? `${s.wheel} ${s.animated}` : s.wheel}
            style={wheelStyle}
          />
        </div>
        <div className={s.footer}>
          <div
            className={s.spinBtnWrapper}
            style={showPopup ? { cursor: "default" } : null}
            onClick={() => {
              if (!showPopup) {
                spinWheel();
              } else {
                setShowPopup(false);
              }
            }}
            disabled={isSpinning}
          >
            {currentWheel?.wheel?.includes("purple") && (
              <>
                <img
                  src={decoratorButton}
                  style={{ position: "absolute", top: -52, zIndex: 100 }}
                />
                <img
                  src={decoratorPointer}
                  style={{ position: "absolute", bottom: -45, zIndex: 100 }}
                />
                <img
                  src={lightDecorator}
                  style={{
                    position: "absolute",
                    right: -50,
                    top: -45,
                    zIndex: 100,
                  }}
                />
                <img
                  src={lightDecorator}
                  style={{
                    position: "absolute",
                    left: -50,
                    bottom: -45,
                    zIndex: 100,
                  }}
                />
              </>
            )}

            {currentWheel?.wheel?.includes("orange") && (
              <>
                <img
                  src={coin}
                  style={{
                    position: "absolute",
                    bottom: -30,
                    marginLeft: 70,
                    zIndex: 100,
                  }}
                />
              </>
            )}

            <button
              className={s.spinBtn}
              type="button"
              style={{
                backgroundImage: `url(${currentWheel?.button})`,
                width: 290,
                height: 85,
              }}
            >
              {hasSpunOnce ? respinButtonText : spinButtonText}
            </button>
          </div>
        </div>

        {showPopup && (
          <div className={s.prelandPopup} onClick={() => setShowPopup(false)}>
            <img src={currentWheel.popup} className={s.popupBg} />
            <div className={s.popupContent} ref={popupRef}>
              <div className={s.popupTitle}>{popupTitle}</div>
              <div className={s.popupTextContent}>{processedPopupText}</div>
              <div className={s.popupBtn}>
                <img src={currentWheel.button} alt="" className={s.btnBg} />
                <button
                  type="button"
                  disabled={isSpinning}
                  // target="_blank"
                  className={s.popupSpinBtn}
                >
                  {popupButtonText}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdaptiveWheel;
